import { GeneticsModel, QueueModel, RaceModel } from ".";
import { toInteger } from '../utils';

export class HoundModel extends GeneticsModel {
  id: number;
  token_id: string;
  owner: string;
  totalRuns: number;
  firstPlace: number;
  secondPlace: number;
  thirdPlace: number;
  staminaLastUpdate: Date;
  staminaRefill1x: string;
  stamina: number;
  staminaPerTimeUnit: number;
  staminaCap: number;
  breedingCooldown: number;
  breedingCooldownCurrency: string;
  breedingCooldownTimeUnit: number;
  breedingFee: string;
  extensionTraits: string;
  specie: number;
  lastBreed: Date;
  lastEnqueue: Date;
  availableToBreed: Boolean;
  geneticSequence: string;
  generation: string;
  children: HoundModel[];
  maleParent: HoundModel;
  femaleParent: HoundModel;
  name: string;
  token_uri: string;
  custom: Boolean;
  running: Boolean;
  queues: QueueModel[];
  races: RaceModel[];
  birthDate: Date;
  chain_id: number;
  breedingFeeCurrency: string;
  staminaRefillCurrency: string;
  staminaCurrency: string;
  createdAt: Date;
  updatedAt: Date;

  constructor(hound: Partial<HoundModel> = {}) {
    super(hound.geneticSequence);

    this.id = hound.id!;
    this.token_id = hound.token_id!;
    this.owner = hound.owner!;
    this.totalRuns = hound.totalRuns!;
    this.firstPlace = hound.firstPlace!;
    this.secondPlace = hound.secondPlace!;
    this.thirdPlace = hound.thirdPlace!;
    this.staminaLastUpdate = hound.staminaLastUpdate!;
    this.staminaRefill1x = hound.staminaRefill1x!;
    this.stamina = hound.stamina!;
    this.staminaPerTimeUnit = hound.staminaPerTimeUnit!;
    this.staminaCap = hound.staminaCap!;
    this.breedingCooldown = hound.breedingCooldown!;
    this.breedingCooldownCurrency = hound.breedingCooldownCurrency!;
    this.breedingCooldownTimeUnit = hound.breedingCooldownTimeUnit!;
    this.breedingFee = hound.breedingFee!;
    this.extensionTraits = hound.extensionTraits;
    this.specie = hound.specie!;
    this.lastBreed = hound.lastBreed!;
    this.lastEnqueue = hound.lastEnqueue;
    this.availableToBreed = hound.availableToBreed!;
    this.geneticSequence = hound.geneticSequence!;
    this.generation = hound.generation!;
    this.children = hound.children!;
    this.maleParent = hound.maleParent!;
    this.femaleParent = hound.femaleParent!;
    this.name = hound.name!;
    this.token_uri = hound.token_uri!;
    this.custom = hound.custom!;
    this.running = hound.running!;
    this.queues = hound.queues!;
    this.races = hound.races!;
    this.birthDate = hound.birthDate!;
    this.chain_id = hound.chain_id!;
    this.breedingFeeCurrency = hound.breedingFeeCurrency;
    this.staminaRefillCurrency = hound.staminaRefillCurrency;
    this.staminaCurrency = hound.staminaCurrency;
    this.createdAt = hound.createdAt;
    this.updatedAt = hound.updatedAt;
  }

  getStaminaPercentage(): number {
    return toInteger((this.stamina / this.staminaCap) * 100);
  }  

  getGeneration(): string {
    switch (this.generation) {
      case '1':
        return 'Titan'
      case '2':
        return 'God'
      case '3':
        return 'Demigod'
      default:
        return `Gen. ${this.generation}`;
    }
  }
  
}
